import { expVal } from '@atlassian/jira-feature-experiments';
import type { FormatMessage } from '@atlassian/jira-shared-types/src/general.tsx';
import messages from './messages.tsx';

/**
 * Given a JQL function name, this function returns its i18n label
 * @param name JQL function name, e.g. "subTaskIssueTypes"
 * @param formatMessage react-intl's formatMessage function
 * @returns {string} i18n label for the JQL function, e.g. "All sub-task issue types"
 */
export const getFunctionLabel = (name: string, formatMessage: FormatMessage): string => {
	let messageKey = name.toLowerCase();
	if (expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)) {
		const refreshedMessageKey = `${messageKey}IssueTermRefresh`;
		if (refreshedMessageKey in messages) {
			messageKey = refreshedMessageKey;
		}
	}
	// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ subtaskissuetypes: MessageDescriptorV2; standardissuetypes: MessageDescriptorV2; currentuser: MessageDescriptorV2; }'.
	const message = messages[messageKey];
	if (message) return formatMessage(message);
	return name;
};
